import { connect } from 'dva';
import DocumentWarning from '../../shared/Document/DocumentWarning';
import { createSelector } from 'reselect';
import {
  getApplicantPassportStatus,
  getApplicantPassportDueDate,
} from '../../../selectors/applicant';
import { Elk } from '../../../models/elk';
import { ApplicantFields } from '../../../models/applicant';
import { PassportWarning } from '../../../constants/document';

const mapStateToProps: (state: {
  applicant: ApplicantFields;
  elk: Elk;
}) => PassportWarning = createSelector(
  getApplicantPassportStatus,
  getApplicantPassportDueDate,
  (status, passportDueDate) => {
    return {
      status,
      passportDueDate,
    };
  }
);

export default connect(mapStateToProps)(DocumentWarning);
